import Plus from "@website/icons/components/plus";
import { useInput } from "@website/ui-old/datepicker/components/input/input.hook";
import styles from "@website/ui-old/datepicker/components/input/input.module.scss";
import { InputPropertiesType } from "@website/ui-old/datepicker/components/input/input.types";
import { TextField } from "@website/ui-old/text-field";
import { FC, memo } from "react";

const Input: FC<InputPropertiesType> = (properties) => {
  const {
    mode,
    fullWidth,
    helperText,
    error,
    changeableMode,
    hideIcons,
    hideBorders,
    hasTitleLabel
  } = properties;
  const {
    rootProps,
    startTextFieldProperties,
    endEnableButtonProperties,
    endTextFieldProperties,
    endEnableButtonText
  } = useInput(properties);

  return (
    <div
      {...rootProps}
      className={`${styles["input"]} ${fullWidth ? styles["full-width"] : ""} ${
        error ? styles["error"] : ""
      }`}
    >
      <div className={styles["inputs-container"]}>
        <div className={styles["text-field-container"]}>
          <TextField {...startTextFieldProperties} />
        </div>
        {mode === "single" ? (
          changeableMode ? (
            <>
              {!hideIcons && (
                <div className={styles["middle"]}>
                  <div className={styles["middle-line"]} />
                </div>
              )}

              <button
                className={`${styles["enable-second-mode-button"]} ${
                  hideBorders ? "!border-0" : ""
                } ${hasTitleLabel ? "!justify-start" : ""}`}
                {...endEnableButtonProperties}
              >
                {endEnableButtonText}
                <Plus />
              </button>
            </>
          ) : null
        ) : (
          <>
            {!hideBorders && (
              <div className={styles["middle"]}>
                <div className={styles["middle-line"]} />
              </div>
            )}

            <div className={styles["text-field-container"]}>
              <TextField {...endTextFieldProperties} />
            </div>
          </>
        )}
      </div>
      {helperText ? (
        <div className={styles["helper-text"]}>{helperText}</div>
      ) : null}
    </div>
  );
};

const InputMemoized = memo(Input);
/**
 * @deprecated please use @website/ui instead
 */
export { InputMemoized /**
 * @deprecated please use @website/ui instead
 */ as Input };
